// import React from "react";
// import React, { useState } from 'react';
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { FIELDS, STEPS } from '../utils/constants';
import { useFormStateContext } from '../utils/hooks';
import {
  InputField,
  InputError,
  InputContainer,
  InputLabel,
  Flex,
  Button,
} from '../utils/styles';
import style from '../utils/style.css'
 
export const MobileForm = () => {
  const { fields, setStep, updateFields } = useFormStateContext();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...fields.contact,
    },
  });

  const onSubmit = (data) => {
    console.log(data);
    updateFields(FIELDS.CONTACT, data);
    // setStep(STEPS.MOBILE);
    setStep(STEPS.PRIVACYCONSENT);
  };

  const goBack = () => {
    // setStep(STEPS.EMAIL);
    setStep(STEPS.CONTACT);
  };

  const onError = (errors, event) => {
    console.log(errors);
    console.log(event);
  };
const [days, setDays] = useState([1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]);
const [months, setMonths] = useState(['January','February','March','April','May','June','July','August','September','October','November','December']);
const [years, setYears] = useState([]);

// create an array of years from 18 years ago to 100 years ago
const currentYear = new Date().getFullYear();
const earliestYear = currentYear - 118;
const latestYear = currentYear - 18;
const yearRange = Array.from({length: latestYear - earliestYear + 1}, (_, i) => latestYear - i);
useEffect(() => {
  setYears(yearRange);
}, []);

const [promotionChannels, setPromotionChannels] = useState({
  email: false,
  sms: false,
  phone: false,
  post: false,
});

const [emailChecked, setEmailChecked] = useState();
const [smsChecked, setSmsChecked] = useState();
const [phoneChecked, setPhoneChecked] = useState();
const [postChecked, setPostChecked] = useState();


const [options, setOptions] = useState({
  email: false,
  sms: false,
 phone: false,
  post: false,
});

const handleChange = (event) => {
  const { name, checked } = event.target;
 setOptions({ ...options, [name]: checked });
};

  return (
    <div className="base-form">
      <form onSubmit={handleSubmit(onSubmit, onError)}>
     <div className='button-back'>
         <Button
           type="button"
           children="Back"
           secondary
            style={{ margin: '0 10px' }}
            onClick={goBack}
          > 
         {/* <i class="fa fa-angle-left" aria-hidden="true"></i> */}
            <i class="fa-solid fa-arrow-left"></i>
         </Button>    
           <h4>Enter Your Details</h4>
          <div className='step-num'>
             <h4>
                2/3
             </h4>
           </div>
       </div> 
        <div className="f-container">
        <label className='name'>First Name</label>
         <InputContainer style={{ margin: '0px 0 20px 0' }} error={errors.firstName}>
            <Flex alignItems="center" justifyContent="space-between">
             
              <InputLabel htmlFor="firstName" children="" />
              {errors.firstName && (
                <InputError children={errors.firstName.message} />
              )}
            </Flex>
            <InputField
              id="firstName"
              placeholder='joe'
              {...register('firstName', {
               required: 'Name required',
              })}
           />
          </InputContainer>

         <label className='name'>Last Name</label>
         <InputContainer style={{ margin: '0px 0 20px 0' }} error={errors.lastName}>
           <Flex alignItems="center" justifyContent="space-between">
             {/* <InputLabel htmlFor="lastName" children="Last Name" /> */}
              <InputLabel htmlFor="lastName" children="" />
             {errors.lastName && (
               <InputError children={errors.lastName.message} />
             )}
           </Flex>
            <InputField
             id="lastName"
              placeholder='taylor'
             {...register('lastName', {
               required: 'Last name required',
             })}
           />
          </InputContainer>

          <label className='name'>Gender</label>
          <InputContainer style={{ margin: '0px 0 20px 0' }} error={errors.gender}>
            <Flex alignItems="center" justifyContent="space-between">
              <InputLabel htmlFor="gender" children="" />
             {errors.gender && (
                <InputError children={errors.gender.message} />
             )}
            </Flex>
            <div className="selector">
             <div className="selecotr-item">
               <input type="radio" id="male" name="gender" className="selector-item_radio" {...register('gender', { required: 'Gender required' })} value="male" />
              <label htmlFor="male" className="selector-item_label">Male</label>
              </div>
              <div className="selecotr-item">
               <input type="radio" id="female" name="gender" className="selector-item_radio" {...register('gender', { required: 'Gender required' })} value="female" />
                <label htmlFor="female" className="selector-item_label">Female</label>
              </div>
              <div className="selecotr-item">
               <input type="radio" id="other" name="gender" className="selector-item_radio" {...register('gender', { required: 'Gender required' })} value="other" />
                <label htmlFor="other" className="selector-item_label">Other</label>
             </div>
            </div>
            {/* {errors.gender && (
              <InputError children={errors.gender.message} />
           )} */}
          </InputContainer>

          <InputContainer style={{ margin: '0px 0 20px 0' }} error={errors.day || errors.month || errors.year}>
          <div className="row">
           <div className="col-xl-4 col-md-4 colm">
              <div className="form-group">
                <InputLabel htmlFor="day" children="Day" />
                <select name="day" id="day" className="form--control form-control style--two selector-item_label selector-item_label" required {...register('day')}>
                  <option 
                    style={{  
                      background: "#fff",
                      color: "#000"
                    }} 
                    value="">Day</option>
                  {days.map((item) => (
                    <option 
                    style={{  
                      background: "#fff",
                      color: "#000"
                   }}
                    key={item} value={item}>{item}</option>
                  ))}
                </select>
                {errors.day && (
                  <InputError children={errors.day.message} />
                )}
              </div>
            </div>
            <div className="col-xl-4 col-md-4 colm">
              <div className="form-group">
               <InputLabel htmlFor="month" children="Month" />
                <select name="month" id="month" className="form--control form-control style--two selector-item_label" required {...register('month')}>
                 <option 
                  style={{  
                   background: "#fff",
                    color: "#000"
                  }} 
                  value="">Month</option> 
                  {months.map((item, index) => (
                  <option
                    style={{  
                      background: "#fff",
                      color: "#000"
                    }}
                    key={index} value={index+1}>{item}</option>
                 ))}
                </select>
                {errors.month && (
                  <InputError children={errors.month.message} />
                )}
              </div>
            </div>
            <div className="col-xl-4 col-md-4 colm">
              <div className="form-group">
                <InputLabel htmlFor="year" children="Year" />
                <select name="year" id="year" className="form--control form-control style--two selector-item_label" required {...register('year')}>
                  <option 
                  style={{  
                   background: "#fff",
                    color: "#000"
                  }}
                 value="">Year</option>
                  {years.map((item) => (
                    <option 
                    style={{  
                      background: "#fff",
                      color: "#000"
                    }} 
                    key={item} value={item}>{item}</option>
                  ))}
               </select>
                {errors.year && (
                 <InputError children={errors.year.message} />
               )}
             </div>
           </div>
          </div>
          </InputContainer>

          <InputContainer style={{ margin: '0px 0 20px 0' }} error={errors.privacyconsent}>
            <Flex alignItems="center" justifyContent="space-between">
             <InputLabel htmlFor="" children="" />
             {errors.privacyconsent && <InputError children={errors.privacyconsent.message} />}
           </Flex>  
            <InputField
                id="privacyconsent"
                      name="conditions" 
                      value="all"
                      type="checkbox" 
                      {...register('privacyconsent', {
                        // required: 'Terms and conditions is required',
                        pattern: {
                          message: 'Select the privacyconsent',
                        },
                      })}
                checked={emailChecked && smsChecked && phoneChecked && postChecked}
                onChange={() => {
                  const isChecked = !emailChecked && !smsChecked && !phoneChecked && !postChecked;
                  setEmailChecked(isChecked);
                  setSmsChecked(isChecked);
                  setPhoneChecked(isChecked);
                  setPostChecked(isChecked);
              }}
            />
            <label className="terms5" for="privacyconsent">agree to receive marketing and promotional materials via all channels or only via</label>
          </InputContainer> 







          <InputContainer style={{ margin: '0px 0 20px 0' }}  error={errors.promotion}>
            <Flex alignItems="center" justifyContent="space-between">
              <InputLabel htmlFor="promotion" children="" />
             {errors.promotion && (
                <InputError children={errors.promotion.message} />
              )}
            </Flex>
            <div className="selector">
              <div className="selector-item selecotr-item">
                <input
                 type="checkbox"
                  id="emailPromotion"
                  name="emailPromotion"
                  className="selector-item_checkbox"
                  {...register('emailPromotion')}
                  checked={emailChecked}
                  onChange={() => setEmailChecked(!emailChecked)}
                  value="emailPromotion"
                />
                <label htmlFor="emailPromotion" className="selector-item_label">Email</label>
              </div>
              <div className="selector-item selecotr-item">
                <input
                  type="checkbox"
                  id="smsPromotion"
                  name="smsPromotion"
                  className="selector-item_checkbox"
                  {...register('smsPromotion')}
                  checked={smsChecked}
                  onChange={() => setSmsChecked(!smsChecked)}
                  value="smsPromotion"
                />
                <label htmlFor="smsPromotion" className="selector-item_label">SMS</label>
              </div>
              <div className="selector-item selecotr-item">
                <input
                  type="checkbox"
                  id="phonePromotion"
                  name="phonePromotion"
                  className="selector-item_checkbox"
                  {...register('phonePromotion')}
                  checked={phoneChecked}
                  onChange={() => setPhoneChecked(!phoneChecked)}
                  value="phonePromotion"
                />
                <label htmlFor="phonePromotion" className="selector-item_label">Phone</label>
              </div>
              <div className="selector-item selecotr-item">
                <input
                  type="checkbox"
                  id="postPromotion"
                  name="postPromotion"
                  className="selector-item_checkbox"
                  {...register('postPromotion')}
                  checked={postChecked}
                  onChange={() => setPostChecked(!postChecked)}
                  value="postPromotion"
                />
                <label htmlFor="postPromotion" className="selector-item_label">Post</label>
              </div>
            </div>
          </InputContainer>






             {/* <div style={{ margin: '0px 0 20px 0' }}>
            <div className="selector">
             <div className="selector-item selecotr-item">
                <input
                  type="checkbox"
                  id="emailPromotion"
                 name="emailPromotion"
                  className="selector-item_checkbox"
                  {...register('emailPromotion')}
                  checked={emailChecked}
                  onChange={() => setEmailChecked(!emailChecked)}
                  value="emailPromotion"
                />
                <label htmlFor="emailPromotion" className="selector-item_label">Email</label>
              </div>
              <div className="selector-item selecotr-item">
               <input
            type="checkbox"
           id="smsPromotion"
            name="smsPromotion"
            className="selector-item_checkbox"
            checked={smsChecked}
           onChange={() => setSmsChecked(!smsChecked)}
          />
          <label htmlFor="smsPromotion" className="selector-item_label">
            SMS
          </label>
        </div>
        <div className="selector-item">
          <input
            type="checkbox"
            id="phonePromotion"
           name="phonePromotion"
            className="selector-item_checkbox"
            checked={phoneChecked}
            onChange={() => setPhoneChecked(!phoneChecked)}
          />
          <label htmlFor="phonePromotion" className="selector-item_label">
            Phone
          </label>
        </div>
        <div className="selector-item">
          <input
            type="checkbox"
            id="postPromotion"
            name="postPromotion"
            className="selector-item_checkbox"
            checked={postChecked}
            onChange={() => setPostChecked(!postChecked)}
          />
          <label htmlFor="postPromotion" className="selector-item_label">
            Post
          </label>
        </div>
      </div>
    </div> */}
        <div className="for-button-manage">
          <div className='button-next'>
            <Button children="Next" >Next Step<span className="enter"></span>  <i class="fa-solid fa-arrow-right"></i> </Button>
          </div>
          {/* <p class="hidden-xs">&nbsp;</p> */}
          <div class="terms5">
            <p className='text-center'> <a href="/login">Already have an account? </a>
            </p>
          </div>
        </div>

        </div>
      </form>
    </div>
  );
};







// import React from 'react';
// import { useForm } from 'react-hook-form';
// import { FIELDS, STEPS } from '../utils/constants';
// import { useFormStateContext } from '../utils/hooks';
// import {
//   InputField,
//   InputError,
//   InputContainer,
//   InputLabel,
//   Flex,
//   Button,
// } from '../utils/styles';

// import PhoneInput from 'react-phone-input-2'
// import 'react-phone-input-2/lib/style.css'

// export const MobileForm = () => {
//   const { fields, setStep, updateFields } = useFormStateContext();
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm({ defaultValues: { mobile: fields.mobile } });

//   const goBack = () => {
//     setStep(STEPS.CONTACT);
//   };

//   const onSubmit = (data) => {
//     console.log(data);
//     updateFields(FIELDS.MOBILE, data.mobile);
//     // setStep(STEPS.REVIEW);
//     setStep(STEPS.BIRTHDATE);
//   };

//   const onError = (errors, event) => {
//     console.log(errors);
//     console.log(event);
//   };

 

//   return (
//     <div className="base-form">
//       <form onSubmit={handleSubmit(onSubmit, onError)}>
//         <div className='button-back'>
//             <Button
//               type="button"
//               children="Back"
//               secondary
//               style={{ margin: '0 10px' }}
//               onClick={goBack}
//             > <i class="fa fa-angle-left" aria-hidden="true"></i></Button> 
//              <h4>Enter mobile</h4>   
//           </div> 
//           <div className="f-container">
//             <label className='name'>Mobile Number</label>
//             <InputContainer style={{ margin: '10px 0' }} error={errors.mobile}>
//               <Flex alignItems="center" justifyContent="space-between">
//                 <InputLabel htmlFor="" children="" />
//                 {errors.mobile && <InputError children={errors.mobile.message} />}
//               </Flex>
              

//               {/* <InputField
//                 id="mobile"
//                 type="number" 
//                 // name="mobile" 
//                 placeholder='4444666666'
//                 maxLength={10}
//                 min="10" max="10"
                
//                 // {...register('mobile', {
//                 //   required: 'Mobile is required',
//                 //   pattern: {
//                 //     message: 'Invalid mobile number',
//                 //     value: /^\d{10}$/,
//                 //   },
//                 // })}
//               /> */}
//               <PhoneInput
//                   name="mobile" 
//                   id="mobile"
//                   country={'mt'}
//                   value={''}
//                   onChange={""}
//                   placeholder="Enter Phone Number"
     

                  
//                   // {...register('mobile', {
//                   //     required: 'Mobile is required',
//                   //     pattern: {
//                   //       message: 'Invalid mobile number',
//                   //       value: /^\d{10}$/,
//                   //     },
//                   //   })}
//                 />
//             </InputContainer>
//             {/* <div className='button-next'>
//               <Button
//                 type="button"
//                 children="Back"
//                 secondary
//                 style={{ margin: '0 10px' }}
//                 onClick={goBack}
//               >Back <i class="fa fa-angle-left" aria-hidden="true"></i></Button>
//               <Button children="Next" />
//             </div> */}


//           <div className='button-next'>
//             <Button children="Next" >Press <span className="enter">Enter</span>  <i class="fa fa-angle-right" aria-hidden="true"></i></Button>
//           </div>
//           <p class="hidden-xs">&nbsp;</p>
//           <div class="terms5">
//             <p className='text-center'> Already have an account with us? <a href="/login">Please Sign In</a>
//             </p>
//           </div>
//         </div>
//       </form>
//     </div>
//   );
// };
